import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { userInfoLinkedBusinessAccountsCacheKey } from "./constants";
import type { UserInfoLinkedBusinessAccountsApiProps, UserInfoLinkedBusinessAccountsResponse } from "./types";

export const getUserInfoLinkedBusinessAccountsByIdentifier = reactQueryFetcherAdapter(
  userInfoLinkedBusinessAccountsCacheKey,
  (
    signal,
    { userIdentifier, pageNumber, pageSize }: UserInfoLinkedBusinessAccountsApiProps
  ): Promise<UserInfoLinkedBusinessAccountsResponse> => {
    return fetch<UserInfoLinkedBusinessAccountsResponse>(
      `/apps/user_info_linked_business_accounts/${encodeURIComponent(userIdentifier)}`,
      "GET",
      {
        page_number: pageNumber,
        page_size: pageSize,
      },
      { signal }
    );
  }
);
